import React from "react"
import autobind from "class-autobind"
import strings from "../../../localization/strings"
import PositionSelector from "../PositionSelector"
import { IJobDocument, IPosition, IUserPayrollData } from "../../../models"
import * as api from "../../../api"
import * as payGroupAndTypeHelper from "../../../helpers/payGroupAndTypeHelper"
import Positions from "../Positions"
import _ from "lodash"
import { checkPositionFieldAvailable } from "../../../helpers/positionHelper"
import accountStore from "../../../stores/AccountStore"

interface IProps {
    saveClicked: boolean
    defaultPositionId?: string
    positions?: IPosition[]
    defaultPunchHierarchyId: string
    defaultPunchJobId: string
    defaultPunchPhaseId: string
    userPayrollData: IUserPayrollData
    defaultJob: IJobDocument
}
interface IState {
    defaultPositionId: string
    errorDefaultPositionId: string
    newEmpPositions: IPosition[]
    defaultPositionCandidates: IPosition[]
}

export default class EmpNewPositions_DefaultPositionSelector extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            defaultPositionId: props.defaultPositionId ? props.defaultPositionId : null,
            errorDefaultPositionId: null,
            newEmpPositions: props.positions ? props.positions : [],
            defaultPositionCandidates: [],
        }
        autobind(this)
    }

    componentDidMount() {
        this.getPositions(this.props)
    }

    componentWillReceiveProps(nextProps: IProps) {
        (this.props.defaultPunchHierarchyId !== nextProps.defaultPunchHierarchyId ||
            this.props.defaultPunchJobId !== nextProps.defaultPunchJobId ||
            this.props.defaultPunchPhaseId !== nextProps.defaultPunchPhaseId
        ) &&
            this.getPositions(nextProps)
        if (!_.isEqual(this.props.userPayrollData, nextProps.userPayrollData)) {
            this.checkValidate(nextProps)
        }
    }

    async getPositions(props: IProps) {
        const response = await api.getNewEmployeePositions(this.state.newEmpPositions, props.defaultPunchHierarchyId ? props.defaultPunchHierarchyId : "", props.defaultPunchJobId ? props.defaultPunchJobId : "", props.defaultPunchPhaseId ? props.defaultPunchPhaseId : "")
        const defaultPositionCandidates = response.data as IPosition[]

        this.setState({
            defaultPositionCandidates,
            defaultPositionId: this.state.defaultPositionId && defaultPositionCandidates.find(i => i.Id === this.state.defaultPositionId) ? this.state.defaultPositionId : null
        }, () =>
            this.checkValidate(props)
        )
    }

    checkValidate(props: IProps) {
        if (this.state.defaultPositionId) {
            const defaultPosition = this.state.defaultPositionCandidates.find(item => item && item.Id === this.state.defaultPositionId)
            const linkedPayTypes = payGroupAndTypeHelper.getLinkedPayTypes(payGroupAndTypeHelper.getPayGroupIdByUserPayrollData(props.userPayrollData, props.defaultJob))
            if (defaultPosition.PayTypeId && !linkedPayTypes.find(item => item.Id === defaultPosition.PayTypeId)) {
                this.setState({ errorDefaultPositionId: strings.Its_not_valid_for_pay_group })
            }
            else {
                this.setState({ errorDefaultPositionId: "" })
            }
        }
        else {
            this.setState({ errorDefaultPositionId: "" })
        }
    }

    handleChange(newEmpPositions: IPosition[]) {
        this.setState({ newEmpPositions }, () =>
            this.getPositions(this.props)
        )
    }

    render() {
        return (
            <div>
                <PositionSelector
                    showEmpty
                    positions={this.state.defaultPositionCandidates}
                    positionId={this.state.defaultPositionId}
                    label={checkPositionFieldAvailable('singular') ? `Default ${accountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}` : strings.DefaultPosition}
                    onSave={defaultPositionId => this.setState({ defaultPositionId }, () => this.checkValidate(this.props))}
                    style={{ width: "45%" }}
                    errorText={this.props.saveClicked ? this.state.errorDefaultPositionId : null}
                />
                <div style={{ marginTop: 10, marginBottom: 20 }}>
                    <Positions
                        isEmployee
                        isDialog
                        positions={this.state.newEmpPositions}
                        usablePositions={[]}
                        payrollPayGroupData={payGroupAndTypeHelper.getPayrollPayGroupDataByUserPayrollData(this.props.userPayrollData, this.props.defaultJob)}
                        handleAdd={position => {
                            const { newEmpPositions } = this.state
                            newEmpPositions.push(position)
                            this.handleChange(newEmpPositions)
                        }}
                        handleUpdate={position => {
                            const { newEmpPositions } = this.state
                            const indexOf = newEmpPositions.findIndex(i => i.Id === position.Id)
                            if (indexOf > -1) {
                                newEmpPositions[indexOf] = position
                            }
                            this.handleChange(newEmpPositions)
                        }}
                        handleDelete={positions => {
                            let { newEmpPositions } = this.state
                            const deletePositionIds = positions.map(i => i.Id)
                            newEmpPositions = newEmpPositions.filter(i => !deletePositionIds.includes(i.Id))
                            this.handleChange(newEmpPositions)
                        }}
                    />
                </div>
            </div>
        )
    }
}